import { capitalize } from './capitalize';

export const getFullName = (participant?: { surname?: string; name?: string; middleName?: string }) => {
  return `${capitalize(participant?.surname ?? '')} ${capitalize(participant?.name ?? '')} ${capitalize(participant?.middleName ?? '')}`;
};
